import * as React from "react";
import styled from "styled-components";
import Text from "../../elements/Text";
import posed from "react-pose";
import { select } from "@hubper/theme";

import Icon from "../../elements/Icon";

import MenuItem from "./Item";

const Items = styled(
  posed.div({
    open: {
      height: "auto"
    },
    close: {
      height: 0
    }
  })
)`
  overflow: hidden;
  background-color: #f7f7f7;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.1);
` as any;

const Item = styled(Text)<{ active: boolean }>`
  padding: ${select.space(0)} ${select.space(3)};
  color: ${p => select.color(["grey", p.active ? 9 : 6], p)};
  cursor: ${p => (p.active ? "default" : "pointer")};

  &:hover {
    color: ${select.color(["grey", 9])};
  }
`;

type Props = {
  currentLanguage: string;
  languages: Array<{
    language: string;
    display: string;
    flag: string;
  }>;
  onChange: (language: string) => void;
};

function LanguageSelect({ currentLanguage, onChange, languages }: Props) {
  const [isOpen, setOpen] = React.useState(false);

  const handleChange = (lang: string) => {
    if (lang === currentLanguage) {
      return;
    }

    onChange(lang);
    setOpen(false);
  };

  const selectedItem = languages.find(
    item => item.language === currentLanguage
  );

  return (
    <>
      <MenuItem
        style={{
          position: "relative",
          paddingTop: "0.33em",
          paddingBottom: "0.33em"
        }}
        onClick={() => setOpen(!isOpen)}
      >
        {selectedItem ? `${selectedItem.flag} ${selectedItem.display}` : ""}
        <Icon
          name="dropdown"
          size={20}
          style={{
            transition: "0.2s",
            position: "absolute",
            right: 8,
            top: "50%",
            transform: `translateY(-50%) rotate(${isOpen ? 180 : 0}deg)`
          }}
        />
      </MenuItem>
      <Items pose={isOpen ? "open" : "close"}>
        {languages.map((item, index) => {
          return (
            <Item
              key={item.language}
              style={{
                marginTop: index === 0 ? 8 : 4,
                marginBottom: index === languages.length - 1 ? 8 : 0
              }}
              fs={-1}
              active={currentLanguage === item.language}
              onClick={() => handleChange(item.language)}
            >
              {item.flag} {item.display}
            </Item>
          );
        })}
      </Items>
    </>
  );
}

export default LanguageSelect;
